import sdl from '@jds/react-generated-sdl/JDSTextarea';
import type { JDSTextareaProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputTextareaProps } from '../logic';

const Component = (props: InputTextareaProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    state = 'undefined',
    ariaLabel = props.label?.toString(),
    _ariaPlaceholder = props.placeholder?.toString(),
    _ariaRequired = props.required?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { disabled, state, ariaLabel, _ariaPlaceholder, _ariaRequired, ...rest },
    'JDSTextarea',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputTextarea = withLogic(Component) as React.ForwardRefExoticComponent<
  InputTextareaProps & React.RefAttributes<HTMLTextAreaElement>
> & { slotName?: string };

InputTextarea.displayName = 'InputTextarea';
InputTextarea.slotName = 'jds_textarea';

export { InputTextarea, type JDSTextareaProps };
